import Complete from './Complete';
import Profile from './Profile';
import Alert from './Alert';
import JobFunctions from './JobFunctions';
import Category from './Category';
import Experience from './Experience';
import Location from './Location';
import Opportunity from './Opportunity';
import { emailRegex, urlRegex, linkedinProfileRegex } from '../../helpers/regex';

export const STEPS = [
  {
    id: 'jobFunctions',
    title: 'What area do you want to work in?',
    component: JobFunctions,
    timer: 'Less than 3 minutes',
  },
  {
    id: 'experience',
    title: 'What is your level of experience?',
    component: Experience,
    timer: 'Less than 3 minutes',
  },
  {
    id: 'location',
    title: 'Where would you like to work?',
    component: Location,
    timer: 'Less than 2 minutes',
  },
  {
    id: 'category',
    title: 'Which of the following are you more interested in?',
    component: Category,
    timer: 'Less than 2 minutes',
  },
  {
    id: 'opportunity',
    title: 'What is your current job search status?',
    component: Opportunity,
    timer: 'Less than 1 minute',
  },
  {
    id: 'alert',
    title: 'Do you want to get alerts for new relevant jobs?',
    component: Alert,
    timer: 'Less than 1 minute',
  },
  {
    id: 'profile',
    title: 'About you',
    component: Profile,
    timer: 'Last step...',
  },
  {
    id: 'complete',
    title: 'Thanks for signing up',
    component: Complete,
  },
];

export const events = {
  jobFunctions: {
    step: 1,
    name: 'job_function',
  },
  experience: {
    step: 2,
    name: 'experience',
  },
  location: {
    step: 3,
    name: 'locations',
  },
  category: {
    step: 4,
    name: 'topics',
  },
  opportunity: {
    step: 5,
    name: 'job_search_status',
  },
  alert: {
    step: 6,
    name: 'job_alerts',
  },
  profile: {
    step: 7,
    name: 'about_you',
  },
  complete: {
    step: 8,
    name: 'complete',
  },
};

export const onboardingDefault = {
  jobFunctions: [],
  experience: [],
  location: {
    locations: [],
    environment: [],
  },
  category: {},
  opportunity: {},
  profile: {
    email: '',
    cvUrl: null,
    linkedinUrl: '',
    additionalInfo: '',
    termsAgreement: false,
    resumeUrl: '',
  },
  alert: {
    value: {},
    keywords: '',
  },
};

export const mapOnboardingToFormPayload = (payload) => {
  const { profile, jobFunctions, experience, location, opportunity, category, alert } = payload;

  const mappedPayload = {
    email: profile.email,
    linkedinUrl: profile.linkedinUrl,
    jobFunctionIds: jobFunctions.map(({ id }) => id),
    seniority: experience.map(({ value }) => value),
    work_environment: location.environment.map(({ value }) => value),
    locations: location.locations.map(({ label }) => label),
    job_search_status: opportunity.value,
    subscribe_to_job_alerts: alert.value?.value === 'yes',
    topics: Object.keys(category).reduce((acc, key) => {
      acc[key] = category[key].map(({ id }) => id);

      return acc;
    }, {}),
    resumeUrl: resumeUrl.value // eslint-disable-line
  };

  if (alert.keywords) {
    mappedPayload.keywords = alert.keywords;
  }

  if (profile?.cvUrl?.name) {
    mappedPayload.resume = {
      name: profile.cvUrl.name,
      content: profile.cvUrl.content,
    };
  }
  if (profile?.additionalInfo) {
    mappedPayload.websiteUrl = profile.additionalInfo;
  }

  if (profile?.resumeUrl) {
    mappedPayload.resumeUrl = profile.resumeUrl.value;
  }

  return mappedPayload;
};

export const validateSteps = (current, onboarding, steps) => {
  switch (steps[current].id) {
    case 'jobFunctions':
    case 'experience':
      return onboarding[steps[current].id].length > 0;
    case 'location': {
      const { locations, showUsWorkAccess, workAuthorization, environment } = onboarding.location;
      if (!locations.length) return false;

      return !(locations.length && showUsWorkAccess && !workAuthorization) && environment.length > 0;
    }
    case 'category': {
      const keys = Object.keys(onboarding.category);
      if (!keys.length) return false;

      return keys.every((key) => onboarding.category[key].length > 0);
    }
    case 'opportunity': {
      return Object.keys(onboarding.opportunity).length > 0;
    }
    case 'alert': {
      const {
        value: { value },
      } = onboarding.alert;

      return !!value;
    }
    case 'profile': {
      const { email, linkedinUrl, additionalInfo, termsAgreement } = onboarding.profile;
      if (additionalInfo && !urlRegex.test(additionalInfo)) return false;

      return emailRegex.test(email) && linkedinProfileRegex.test(linkedinUrl) && termsAgreement;
    }
    default:
      return true;
  }
};
